import { Alert, Box, Container, Stack, Typography, useTheme } from "@mui/material";
import { Map } from "./map.js";
import { RetailerCard, RetailerCardSkeleton, ThaliaCard } from "./retailer-card.js";
import { SearchBox } from "./search-box.js";
import { useJsApiLoader } from "@react-google-maps/api";
import { useMediaQuery } from "../utilities/index.js";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "next-i18next";
import React from "react";
const LIBRARIES = ["places"];
export const Hermes = ({ showThalia = true }) => {
    const { t } = useTranslation("c-hermes");
    const theme = useTheme();
    const isAtLeastSm = useMediaQuery(theme.breakpoints.up("sm"));
    const bgColor = theme.palette.grey[50];
    const radius = 25000; // in meter
    const defaultCenter = { lat: 52.520008, lng: 13.404954 };
    const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;
    const hermesUrl = process.env.NEXT_PUBLIC_HERMES_API_URL;
    const { isLoaded: isMapLoaded, loadError: mapError } = useJsApiLoader({
        language: process.env.NEXT_PUBLIC_LNG ?? "de",
        googleMapsApiKey: apiKey ?? "",
        libraries: LIBRARIES,
    });
    if (!apiKey || !hermesUrl) {
        throw new Error(`Expected envs NEXT_PUBLIC_GOOGLE_MAPS_API_KEY and NEXT_PUBLIC_HERMES_API_URL to be set.`);
    }
    const [point, setPoint] = React.useState(isAtLeastSm ? defaultCenter : undefined);
    const handlerPlaceChange = (place) => {
        if (place && place.geometry && place.geometry.location) {
            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();
            setPoint({ lat, lng });
        }
        return;
    };
    const { data = [], error, isLoading, isFetching, isFetchedAfterMount, } = useQuery(["hermes", { lat: point?.lat ?? 0, lng: point?.lng ?? 0 }], async ({ signal }) => {
        if (!point)
            return;
        const resp = await fetch(`${process.env.NEXT_PUBLIC_HERMES_API_URL}/query?lat=${point.lat}&lng=${point.lng}`, {
            signal,
        });
        return resp.json();
    }, { enabled: !!point });
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, { maxWidth: "md", sx: { pb: { xs: point ? 0 : 6, sm: 0 } } }, isMapLoaded && (React.createElement(SearchBox, { disabled: isFetching, onPlaceChange: handlerPlaceChange, placeholder: isAtLeastSm
                ? t("searchbox-placeholder", "Bitte gib den Namen deiner Stadt ein, z. B. Berlin")
                : t("searchbox-placeholder-short", "Bitte gib den Namen deiner Stadt ein") }))),
        (isAtLeastSm || point) && (React.createElement(Stack, { direction: { xs: "column", sm: "row" }, sx: { backgroundColor: bgColor, boxShadow: "sectionTop", mt: { xs: 6, lg: 8 } } },
            React.createElement(Box, { sx: { pt: { xs: 4, sm: 6 }, pb: { xs: 4, sm: 8 }, maxWidth: { xs: "100%", sm: "50%" } } },
                React.createElement(Container, { maxWidth: "lg" },
                    React.createElement(Typography, { component: "h2", variant: "h3", sx: { pb: 1 } }, t("results-heading", "Ergebnisse")),
                    data.length === 0 && isFetchedAfterMount && !isLoading && !error && (React.createElement(Typography, { variant: "body1" }, t("notice-no-retailers-found", "Wir haben im Umkreis von 25 km leider keine Händler gefunden, aber:"))),
                    isLoading && (React.createElement(Typography, { variant: "body1" }, t("notice-search-in-progress", "Wir suchen nach Händlern im Umkreis."))),
                    !isLoading && data.length > 0 && (React.createElement(Typography, { variant: "body1" }, t("notice-retailers-found", "Wir haben im Umkreis von 25 km folgende Händler gefunden:"))),
                    !!error && (React.createElement(Alert, { severity: "error" }, t("notice-search-error", "Beim Laden der Ergebnisse ist leider ein Fehler aufgetreten. Bitte lade die Seite erneut oder kontaktiere uns unter support@culinario-mortale.de"))),
                    React.createElement(Stack, { component: "ul", direction: "column", spacing: { xs: 2, sm: 3 }, sx: { padding: 0, listStyleType: "none" } },
                        !isLoading && (React.createElement(React.Fragment, null,
                            data.map((retailer) => (React.createElement(RetailerCard, { key: retailer._id, retailer: retailer }))),
                            showThalia && React.createElement(ThaliaCard, null))),
                        isLoading &&
                            Array(4)
                                .fill("")
                                .map((_, ix) => React.createElement(RetailerCardSkeleton, { key: `retailer-skeleton-${ix}` }))))),
            React.createElement(Box, { sx: { flexGrow: 1 } },
                isMapLoaded && (React.createElement(Map, { defaultCenter: defaultCenter, defaultZoom: 11, retailers: data, point: point, radius: radius })),
                mapError && (React.createElement(Container, { maxWidth: "lg" },
                    React.createElement(Alert, { severity: "error" }, t("notice-map-error", "Beim Laden der Karte ist leider ein Fehler aufgetreten. Bitte lade die Seite erneut oder kontaktiere uns unter support@culinario-mortale.de")))))))));
};
//# sourceMappingURL=hermes.js.map